import React, { Component } from "react";
import moment from "moment";
import Modal from "react-modal";
import LazyLoad from "react-lazyload";
import I18n from "../../i18n/I18n";
import CONFIG from "../../config";
import styles from "./DetailView.scss";
import Tabs from "../common/tabs";
import Helper from "../../helper/Helper";

class DetailView extends Component {
  constructor() {
    super();
    this.state = {
      selectedDetailsTab: "finance"
    };
  }

  renderFinanceView() {
    const { user, financeView, isFinanceLoading } = this.props;
    const { item } = financeView;

    return (
      <div className={styles.ctr}>
        <table className={styles.table}>
          <thead>
            <tr className={`${styles.row} ${styles.head}`}>
              <th>
                {I18n.getText(
                  "statement-details.finance-view-statement-number",
                  {},
                  "Statement Number"
                )}
              </th>
              <th>
                {I18n.getText(
                  "statement-details.finance-view-statement-type",
                  {},
                  "Type"
                )}
              </th>
              <th>
                {I18n.getText(
                  "statement-details.finance-view-statement-total",
                  { currency: this.props.currencyCode },
                  "Amount ({currency})"
                )}
              </th>
            </tr>
          </thead>
          <tbody>
            {financeView && financeView.statement.map((item, idx) => (
              <tr key={idx}>
                <td>{item.ref}</td>
                <td>{item.transaction}</td>
                <td>
                  <span
                    className={`${
                      item.amount < 0 ? styles.negative : styles.positive
                    }`}
                  >
                    {I18n.formatCurrency(
                      Helper.formatPrice(item.amount, this.props.currencyCode)
                    )}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderOrderView() {
    const { user, orderView } = this.props;
    const { item } = orderView;

    return (
      <div className={styles.ctr}>
        <table className={styles.table}>
          <thead>
            <tr className={`${styles.row} ${styles.head}`}>
              <th>
                {I18n.getText(
                  "statement-details.order-view-purchase-id",
                  {},
                  "Purchase Id"
                )}
              </th>
              <th>
                {I18n.getText(
                  "statement-details.order-view-return-id",
                  {},
                  "Return Id"
                )}
              </th>
              <th>
                {I18n.getText(
                  "statement-details.order-view-status",
                  {},
                  "Status"
                )}
              </th>
              <th>
                {I18n.getText(
                  "statement-details.order-view-amount",
                  { currency: this.props.currencyCode },
                  "Amount ({currency})"
                )}
              </th>
              <th>
                {I18n.getText(
                  "statement-details.order-view-created",
                  {},
                  "Created At "
                )}
              </th>
            </tr>
          </thead>
          <tbody>
            {orderView.orders.map((item, idx) => (
              <tr key={idx}>
                <td>
                  <span>{item.purchase_order_id}</span>
                </td>
                <td>{item.return_order_id}</td>
                <td>{item.status}</td>
                <td>
                  <span
                    className={`${
                      item.price < 0 ? styles.negative : styles.positive
                    }`}
                  >
                    {I18n.formatCurrency(
                      Helper.formatPrice(item.price, this.props.currencyCode)
                    )}
                  </span>
                </td>
                <td>
                  {moment(item.created_at).format("YYYY-MM-DD [at] h:mm:ss a")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const orderView = this.props.orderView || "";
    const financeView = this.props.financeView || "";
    const placeholder = (
      <img
        src={`${CONFIG.BASE_IMG_URL}nr/misc/product-image-default.jpg`}
        alt="Placeholder"
      />
    );
    const { item } = financeView;
    const config = {
      tabs: [
        {
          title: I18n.getText(
            "statement-details.financial-view",
            {},
            "Financial View"
          ),
          key: "finance",
          content: this.renderFinanceView()
        },
        {
          title: I18n.getText("statement-details.order-view", {}, "Order View"),
          key: "order",
          content: this.renderOrderView()
        }
      ]
      //   selectedTab: this.state.selectedDetailsTab,
      //   handleSelect: (selectedTab) => this.changeSelectedTab(selectedTab),
    };

    return (
      <div className={styles.innerContent}>
        {this.props.isFinanceLoading ? (
          <div>Loading..</div>
        ) : (
          <div>
            <div className={styles.productRow}>
              <div className={styles.imgCtr}>
                <LazyLoad
                  height="100%"
                  once
                  placeholder={placeholder}
                  offset={100}
                >
                  <img
                    className={styles.productImage}
                    src={Helper.getTransformationUrl(
                      (item && item.imagekey) || (item && item.image_key)
                    )}
                    alt="productImage"
                  />
                </LazyLoad>
              </div>
              <div className={styles.productInfo}>
                <span className={styles.title}>{item && item.title}</span>
            <span className={styles.sku}>{item && item.sku}</span>
              </div>
            </div>
            <Tabs config={config} />
          </div>
        )}
      </div>
    );
  }
}

export default DetailView;



// WEBPACK FOOTER //
// ./src/components/statement/DetailView.js